/* @flow */

export const RESET_PASSWORD_SUPPORT_SECTION = 'RESET_PASSWORD_SUPPORT_SECTION';
export const SHOW_PASSWORD_SUPPORT_LINK_SECTION =
  'SHOW_PASSWORD_SUPPORT_LINK_SECTION';
export const SHOW_PASSWORD_SUPPORT_RESET_SECTION =
  'SHOW_PASSWORD_SUPPORT_RESET_SECTION';
export const SHOW_PASSWORD_SUPPORT_CONTACT_SECTION =
  'SHOW_PASSWORD_SUPPORT_CONTACT_SECTION';
